<template>
  <section>
    <review-list :query="query" mode="review" />
  </section>
</template>

<script>
import ReviewList from '@/components/gifts/ReviewList'

export default {
  name: 'Reviews',
  components: { ReviewList },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
